import { useCallback } from 'react';
import useFavoritesStore from '../../../core/stores/favoritesStore';
import useAuthStore from '../../../core/stores/authStore';

/**
 * 환자 즐겨찾기 토글 hook.
 * - userId의 isFavorite 상태 + toggle handler 제공
 * - 내부적으로 favoritesStore 사용 (공용 store 그대로 위임)
 */
export const useFavoriteToggle = (userId: number | string | null | undefined) => {
  const userIds = useFavoritesStore(s => s.userIds);
  const toggleAction = useFavoritesStore(s => s.toggle);
  const pharmacyBrn = useAuthStore(s => s.pharmacy?.business_registration_number);

  const isFavorite = userId != null && userIds.includes(Number(userId));
  const canToggle = !!pharmacyBrn && userId != null;

  const toggle = useCallback(() => {
    if (!canToggle) return;
    toggleAction(pharmacyBrn as string, Number(userId));
  }, [canToggle, toggleAction, pharmacyBrn, userId]);

  return { isFavorite, toggle, canToggle };
};
